<!------------------------------------------------------------------------------
 File: BaseDatePicker
 Created by Keni Williams <kenneth.williams@estuk.co.uk>.
 with: IntelliJ IDEA
 Date: 2019-03-11
 Time: 11:41
------------------------------------------------------------------------------->
<template>
    <input class="datepicker form-control"
           type="text"
           :name="field"
           :tabindex="tabindex"
    >
</template>
<script>
    export default {
        name: "BaseDatePicker",
        components: {},
        props: {
            set_value: '',
            label: {
                type: String,
                default: 'Date'
            },
            field: {
                type: String,
                default: 'date_field'
            },
            set_active: {
                type: Boolean,
                default: true
            },
            set_date: {
                type: String, //format: 'yyyy-mm-dd',
                default: null
            },
            set_now: {
                type: Boolean,
                default: true
            },
            tabindex: {
                type: Number,
                default: 0
            }
        },
        created() {
        },
        destroyed() {
        },
        mounted() {
            /**
             * @func self.$nextTick
             * @namespace self
             */
            let self = this;

            self.$nextTick(function () {
                if (self.set_active) {
                    self.init();
                }
            })
        },
        data() {
            return {
                elm: {},
                vue_picker: {}
            }
        },
        methods: {
            init() {
                let self = this;

                this.elm = window.$(this.$el).pickadate({
                    darktheme: true,
                    onStart: function() {
                        // console.log('Hello there :)')
                    },
                    onRender: function() {
                        // console.log('Whoa.. rendered anew')
                    },
                    onOpen: function() {
                        // console.log('Opened up')
                    },
                    onClose: function() {
                        // console.log('Closed now')
                    },
                    onStop: function() {
                        // console.log('See ya.')
                    },
                    onSet(date) {
                        /**
                         * Receives date in milliseconds and converts to date object
                         * @type {Date}
                         */
                        let dateObject = new Date(date.select);

                        self.$emit('dateSet', dateObject);
                    }
                });
                self.vue_picker = self.elm.pickadate('picker');

                if (self.set_date !== null) {
                    self.vue_picker.set('select', self.set_date, {format: 'yyyy-mm-dd'})
                } else if (this.set_now === true) {
                    self.vue_picker.set('select', new Date())
                }
            },
            destroyDatePicker() {
                this.vue_picker.stop();
            }
        },
        beforeDestroy: function () {
            this.destroyDatePicker();
        },
        watch: {
            set_active(val) {
                if (val) {
                    this.init();
                } else {
                    this.destroyDatePicker();
                }
            }
        },
        computed: {}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/BaseDatePickerComponent.vue?227d3887